export const GET_FLEET_PENDING = "GET_FLEET_PENDING";
export const GET_FLEET_SUCCESS = "GET_FLEET_SUCCESS";
export const GET_FLEET_FAILURE = "GET_FLEET_FAILURE";

export const GET_FLEET_FOR_TRIPS_PENDING = "GET_FLEET_FOR_TRIPS_PENDING";
export const GET_FLEET_FOR_TRIPS_SUCCESS = "GET_FLEET_FOR_TRIPS_SUCCESS";
export const GET_FLEET_FOR_TRIPS_FAILURE = "GET_FLEET_FOR_TRIPS_FAILURE";

export const ADD_FLEET_PENDING = "ADD_FLEET_PENDING";
export const ADD_FLEET_SUCCESS = "ADD_FLEET_SUCCESS";
export const ADD_FLEET_FAILURE = "ADD_FLEET_FAILURE";

export const UPLOAD_FLEET_PENDING = "UPLOAD_FLEET_PENDING";
export const UPLOAD_FLEET_SUCCESS = "UPLOAD_FLEET_SUCCESS";
export const UPLOAD_FLEET_FAILURE = "UPLOAD_FLEET_FAILURE";

export const EDIT_FLEET_PENDING = "EDIT_FLEET_PENDING";
export const EDIT_FLEET_SUCCESS = "EDIT_FLEET_SUCCESS";
export const EDIT_FLEET_FAILURE = "EDIT_FLEET_FAILURE";

export const DELETE_FLEET_PENDING = "DELETE_FLEET_PENDING";
export const DELETE_FLEET_SUCCESS = "DELETE_FLEET_SUCCESS";
export const DELETE_FLEET_FAILURE = "DELETE_FLEET_FAILURE";

export const DOWNLOAD_FLEET_PENDING = "DOWNLOAD_FLEET_PENDING";
export const DOWNLOAD_FLEET_SUCCESS = "DOWNLOAD_FLEET_SUCCESS";
export const DOWNLOAD_FLEET_FAILURE = "DOWNLOAD_FLEET_FAILURE";

export const COMPLETE_VEHICLE_NUMBER_PENDING =
    "COMPLETE_VEHICLE_NUMBER_PENDING";
export const COMPLETE_VEHICLE_NUMBER_SUCCESS =
    "COMPLETE_VEHICLE_NUMBER_SUCCESS";
export const COMPLETE_VEHICLE_NUMBER_FAILURE =
    "COMPLETE_VEHICLE_NUMBER_FAILURE";